import { Redirect, Route } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ component: Component, render, ...rest }) => {
  const authContext = useAuthContext();
  return (
    <Route
      {...rest}
      render={(props) => {
        if (authContext && !authContext.user) {
          return <Redirect to="/login" />;
        }
        return Component ? <Component {...props} /> : render(props);
      }}
    />
  );
};

export default ProtectedRoute;
